import { c as _c } from "react/compiler-runtime";
export default function UserTableHeaderWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="tw-h-full tw-flex tw-items-center tw-justify-between tw-w-full"><h3 className="mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">{children}</h3></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}